"use client";

import { Icon } from "@/components/ui/icon";

interface JobsPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
}

export function JobsPagination({
  page,
  totalPages,
  total,
  onPageChange,
}: JobsPaginationProps) {
  const atFirst = page <= 1;
  const atLast = page >= totalPages;

  return (
    <div className="mt-3 flex items-center justify-between border-t border-border/60 pt-3">
      <span className="text-xs text-foreground/50">
        {total} job{total !== 1 ? "s" : ""}
      </span>
      <nav aria-label="Jobs pagination" className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={atFirst}
          aria-label="Previous page"
          className="flex size-7 items-center justify-center rounded-md text-foreground/65 transition-colors hover:bg-contrast/6 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent"
        >
          <Icon name="IconChevronLeft" size={14} />
        </button>
        <span className="min-w-[56px] text-center text-xs text-foreground/60">
          {page} of {totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={atLast}
          aria-label="Next page"
          className="flex size-7 items-center justify-center rounded-md text-foreground/65 transition-colors hover:bg-contrast/6 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent"
        >
          <Icon name="IconChevronRight" size={14} />
        </button>
      </nav>
    </div>
  );
}
